// Recovered compiled webpack factory 89038. Edit this function expression; run npm run build.
(e, s, a) => {
  a.d(s, { L: () => N });
  var d = a(95155),
    n = a(17237);
  let l = "border-black/15",
    r = "dark:border-white/10",
    i = "bg-black/[0.05]",
    x = "dark:bg-white/[0.06]",
    c = "bg-black/[0.12]",
    t = "dark:bg-white/[0.10]",
    p = `border bg-white/72 dark:bg-[rgba(14,14,16,0.72)] ${l} ${r}`;
  function h() {
    return (0, d.jsxs)("div", {
      className: "fixed inset-[14px] flex flex-col gap-[10px]",
      children: [
        (0, d.jsxs)("div", {
          className: `flex items-center gap-2.5 px-3 h-[40px] rounded-full ${p}`,
          children: [
            (0, d.jsx)("span", {
              className: `h-[14px] w-[14px] rounded-sm ${i} ${x}`,
              "aria-hidden": !0,
            }),
            (0, d.jsx)("span", {
              className: `h-[10px] w-[64px] rounded-sm ${i} ${x}`,
              "aria-hidden": !0,
            }),
            (0, d.jsxs)("span", {
              className: "ml-auto flex items-center gap-2",
              children: [
                (0, d.jsx)("span", {
                  className: `h-[26px] w-[26px] rounded-full ${i} ${x}`,
                  "aria-hidden": !0,
                }),
                (0, d.jsx)("span", {
                  className: `h-[26px] w-[72px] rounded-full ${i} ${x}`,
                  "aria-hidden": !0,
                }),
              ],
            }),
          ],
        }),
        (0, d.jsx)("div", {
          className: `flex-1 min-h-0 rounded-2xl border flex items-center justify-center bg-[#fafafa] dark:bg-[#09090b] ${l} ${r}`,
          children: (0, d.jsx)(n.y, {}),
        }),
        (0, d.jsxs)("div", {
          className: "flex flex-col items-end gap-[8px]",
          "aria-hidden": !0,
          children: [
            (0, d.jsxs)("div", {
              className: `flex items-center gap-2 px-2 h-[54px] rounded-full ${p}`,
              children: [
                (0, d.jsx)("span", { className: `h-[46px] w-[46px] rounded-full ${i} ${x}` }),
                (0, d.jsx)("span", { className: `h-[46px] w-[46px] rounded-full ${i} ${x}` }),
                (0, d.jsx)("span", { className: `h-[46px] w-[64px] rounded-full ${i} ${x}` }),
              ],
            }),
            (0, d.jsxs)("div", {
              className: "w-full flex items-center justify-between",
              children: [
                (0, d.jsxs)("div", {
                  className: `flex items-center gap-2 px-3 h-[38px] rounded-full ${p}`,
                  children: [
                    (0, d.jsx)("span", { className: `h-3.5 w-3.5 rounded-sm ${c} ${t}` }),
                    (0, d.jsx)("span", { className: `h-3.5 w-3.5 rounded-sm ${c} ${t}` }),
                  ],
                }),
                (0, d.jsx)("div", {
                  className: `flex items-center gap-2.5 px-3 h-[38px] rounded-full ${p}`,
                  children: Array.from({ length: 6 }).map((e, s) =>
                    (0, d.jsx)("span", { className: `h-3.5 w-3.5 rounded-full ${c} ${t}` }, s),
                  ),
                }),
              ],
            }),
          ],
        }),
      ],
    });
  }
  let m = "border-black/15",
    o = "dark:border-white/10",
    f = "bg-[#fafafa]",
    u = "dark:bg-[#09090b]",
    $ = "bg-black/[0.05]",
    b = "dark:bg-white/[0.06]",
    j = "bg-black/[0.12]",
    w = "dark:bg-white/[0.10]";
  function N() {
    return (0, d.jsxs)("div", {
      className: "fixed inset-0 z-[9500] overflow-hidden bg-[#e0e0e0] dark:bg-black",
      "aria-busy": "true",
      "aria-label": "Loading editor",
      tabIndex: -1,
      children: [
        (0, d.jsx)("div", { className: "md:hidden", children: (0, d.jsx)(h, {}) }),
        (0, d.jsxs)("div", {
          className: "max-md:hidden fixed inset-[14px] flex gap-[10px]",
          children: [
            (0, d.jsxs)("div", {
              className: "flex-1 flex flex-col min-w-0 gap-[10px]",
              children: [
                (0, d.jsxs)("div", {
                  className: `flex items-center gap-2.5 px-1.5 h-[40px] rounded-xl border bg-white/72 dark:bg-[rgba(14,14,16,0.72)] ${m} ${o}`,
                  children: [
                    (0, d.jsx)("span", {
                      className: `h-[14px] w-[14px] rounded-sm ${$} ${b}`,
                      "aria-hidden": !0,
                    }),
                    (0, d.jsx)("span", {
                      className: `h-[10px] w-[72px] rounded-sm ${$} ${b}`,
                      "aria-hidden": !0,
                    }),
                    (0, d.jsxs)("span", {
                      className: "ml-auto flex items-center gap-2",
                      children: [
                        (0, d.jsx)("span", {
                          className: `h-[26px] w-[140px] rounded-[8px] ${$} ${b}`,
                          "aria-hidden": !0,
                        }),
                        (0, d.jsx)("span", {
                          className: `h-[26px] w-[26px] rounded-[8px] ${$} ${b}`,
                          "aria-hidden": !0,
                        }),
                        (0, d.jsx)("span", {
                          className: `h-[26px] w-[80px] rounded-[8px] ${$} ${b}`,
                          "aria-hidden": !0,
                        }),
                      ],
                    }),
                  ],
                }),
                (0, d.jsx)("div", {
                  className: `flex-1 rounded-2xl border flex items-center justify-center ${f} ${u} ${m} ${o}`,
                  children: (0, d.jsx)(v, {}),
                }),
              ],
            }),
            (0, d.jsxs)("div", {
              className: `shrink-0 w-[280px] overflow-hidden rounded-2xl border flex flex-col ${f} ${u} ${m} ${o}`,
              "aria-hidden": !0,
              children: [
                (0, d.jsxs)("div", {
                  className: "flex items-center justify-between px-3 h-9 shrink-0",
                  children: [
                    (0, d.jsx)("span", { className: `h-3.5 w-3.5 rounded-sm ${j} ${w}` }),
                    (0, d.jsxs)("span", {
                      className: "flex items-center gap-3",
                      children: [
                        (0, d.jsx)("span", { className: `h-3.5 w-3.5 rounded-sm ${j} ${w}` }),
                        (0, d.jsx)("span", { className: `h-3.5 w-3.5 rounded-full ${j} ${w}` }),
                      ],
                    }),
                  ],
                }),
                (0, d.jsxs)("div", {
                  className:
                    "flex flex-col gap-3 px-3 pb-3 [mask-image:linear-gradient(to_bottom,black_55%,transparent)]",
                  children: [
                    (0, d.jsx)(g, { rows: 4, variant: "buttons" }),
                    (0, d.jsx)(g, { rows: 6, variant: "slider", hasTabs: !0 }),
                    (0, d.jsx)(g, { rows: 5, variant: "slider" }),
                    (0, d.jsx)(g, { rows: 6, variant: "slider" }),
                  ],
                }),
              ],
            }),
          ],
        }),
      ],
    });
  }
  function g(e) {
    let { rows: s, variant: a, hasTabs: n = !1 } = e;
    return (0, d.jsxs)("div", {
      className: "flex flex-col gap-1.5",
      children: [
        (0, d.jsxs)("div", {
          className: "flex items-center gap-1.5 px-1 pt-1 pb-1",
          children: [
            (0, d.jsx)("span", { className: `h-2 w-2 rounded-[1.5px] ${j} ${w}` }),
            (0, d.jsx)("span", { className: `h-2 w-14 rounded-sm ${j} ${w}` }),
          ],
        }),
        n &&
          (0, d.jsxs)("div", {
            className: `flex p-0.5 h-7 rounded-md ${$} ${b}`,
            children: [
              (0, d.jsx)("span", {
                className: "flex-1 rounded-[5px] bg-[#fafafa] dark:bg-[#09090b]",
              }),
              (0, d.jsx)("span", { className: "flex-1" }),
            ],
          }),
        Array.from({ length: s }).map((e, s) =>
          "buttons" === a
            ? (0, d.jsx)(
                "div",
                {
                  className: `h-7 w-full rounded-md flex items-center justify-center ${$} ${b}`,
                  children: (0, d.jsx)("span", { className: `h-2 w-16 rounded-sm ${j} ${w}` }),
                },
                s,
              )
            : (0, d.jsxs)(
                "div",
                {
                  className: `h-7 w-full rounded-md flex items-center justify-between px-2.5 ${$} ${b}`,
                  children: [
                    (0, d.jsx)("span", { className: `h-2 w-12 rounded-sm ${j} ${w}` }),
                    (0, d.jsx)("span", { className: `h-2 w-6 rounded-sm ${j} ${w}` }),
                  ],
                },
                s,
              ),
        ),
      ],
    });
  }
  function v() {
    return (0, d.jsx)(n.y, {});
  }
}
